const bimg = (id, crop = "entropy", w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop&crop=${crop}`;

const I1 = bimg("photo-1600210492486-724fe5c67fb0");
const I2 = bimg("photo-1615529182904-14819c35db37");
const I3 = bimg("photo-1519710164239-da123dc03ef4");
const T1 = bimg("photo-1519824145371-296894a0daa9", "bottom");
const T2 = bimg("photo-1519823551278-64ac92734fb1", "top");

export const RMT_POSTS = [
  {
    slug: "rmt-vs-massage-therapist",
    title: "What Is a Registered Massage Therapist — and How an RMT Differs from a Massage Therapist",
    keyword: "RMT vs massage therapist",
    category: "RMT, Insurance & Direct Billing",
    read: "4 min read",
    img: I1,
    excerpt:
      "The letters after a therapist's name decide whether your insurance pays. What RMT means in Canada — and what it means in Alberta specifically.",
    body: [
      {
        p: [
          "In Canada, “RMT” marks a Registered Massage Therapist — a practitioner with a recognized 2,200-hour education, examinations, and registration with a provincial college or professional association. Anyone can offer relaxation services; only those with the training and standing can call themselves RMTs.",
        ],
      },
      {
        h: "The Alberta nuance",
        p: [
          "Massage therapy is not yet provincially regulated in Alberta the way it is in Ontario or British Columbia. Here, the practical marker is graduation from a recognized 2,200-hour program — for example, MaKami College — plus membership in a professional association. That combination is what insurers look for.",
        ],
      },
      {
        h: "Why it matters to you",
        p: [
          "Two reasons. First, extended health benefits in Canada reimburse massage only when the therapist meets the insurer's registration standard. Second, therapeutic work — injuries, chronic pain, prenatal care — deserves the clinical depth that full training provides. At Royal Essence, every session is delivered by an RMT with that foundation.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "is-massage-covered-by-insurance-canada",
    title: "Is Massage Therapy Covered by Insurance in Canada?",
    keyword: "is massage covered by insurance Canada",
    category: "RMT, Insurance & Direct Billing",
    read: "4 min read",
    img: I2,
    excerpt:
      "Usually yes — through extended health benefits, not provincial health care. How coverage typically works and what yours probably includes.",
    body: [
      {
        p: [
          "Provincial health care in Canada does not cover massage therapy. But most employer and private extended health plans do — it is one of the most commonly included paramedical benefits, alongside physiotherapy and chiropractic care.",
        ],
      },
      {
        h: "What typical coverage looks like",
        p: [
          "Most plans cover a percentage (often 80–100%) of each session, up to an annual maximum — commonly $300 to $750 per year, sometimes more. Coverage almost always requires the therapist to be a Registered Massage Therapist meeting the insurer's standard.",
        ],
      },
      {
        h: "How to check yours in five minutes",
        p: [
          "Open your benefits booklet or insurer's app and look for “massage therapy” under paramedical services. Note three things: the annual maximum, the percentage covered, and whether a doctor's referral is required. If anything is unclear, your HR department or the insurer's helpline can confirm in one short call.",
        ],
      },
    ],
    note:
      "Coverage rules vary by plan — confirm your specific plan's requirements before your first appointment. We can help you read the fine print.",
  },
  {
    slug: "massage-therapy-direct-billing",
    title: "How Direct Billing Works for Massage Therapy",
    keyword: "massage therapy direct billing",
    category: "RMT, Insurance & Direct Billing",
    read: "4 min read",
    img: I3,
    excerpt:
      "Direct billing means you pay only what your plan does not cover — if anything. How it works step by step, and why it changes everything about regular care.",
    body: [
      {
        p: [
          "Direct billing is simple: instead of paying the full session price and claiming it back from your insurer, the clinic bills your insurance company directly. You arrive, have your massage, and pay only the portion your plan does not cover — often nothing at all.",
        ],
      },
      {
        h: "What it looks like in practice",
        p: [
          "At your first visit, you provide your plan details (insurer name, policy and ID numbers — a photo of your benefits card works). The clinic submits the claim while you are still in the room, the insurer responds within seconds, and any uncovered remainder is settled before you leave. No forms, no envelopes, no waiting weeks for reimbursement.",
        ],
      },
      {
        h: "Why it matters",
        p: [
          "The real benefit is not convenience — it is consistency. When massage costs you nothing out of pocket at the door, the “I'll stretch it out and wait” habit disappears, and care happens at the rhythm your body actually needs.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "what-to-bring-to-rmt-appointment",
    title: "What to Bring to Your First RMT Appointment",
    keyword: "what to bring to RMT appointment",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I1,
    excerpt:
      "A short checklist so your first visit starts on the table, not in the paperwork.",
    body: [
      {
        p: [
          "A first RMT appointment is easy — a little preparation makes it seamless.",
        ],
      },
      {
        h: "The checklist",
        p: [
          "Your extended health benefits card (or a photo of it) if you plan to use insurance — this enables direct billing on the spot. A doctor's referral letter, only if your specific plan requires one. Comfortable clothing you can move in for the brief assessment conversation. And a rough timeline of your concern: when it started, what makes it better or worse.",
        ],
      },
      {
        h: "What you do not need",
        p: [
          "No special clothes for the massage itself — you will be professionally draped and covered throughout, with only the area being worked uncovered. No shaving, no preparation, no performance. Arrive as you are; that is rather the point.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "rmt-covered-by-benefits",
    title: "How to Find Out If Your Benefits Plan Covers an RMT",
    keyword: "RMT covered by benefits",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I2,
    excerpt:
      "Five minutes, three places to look: your benefits booklet, your insurer's app, and one phone call. Here is exactly what to search for.",
    body: [
      {
        p: [
          "Most Canadians with workplace benefits have massage coverage and never use it — simply because checking feels like homework. It takes less time than choosing what to watch tonight.",
        ],
      },
      {
        h: "Three fast ways to check",
        p: [
          "Your benefits booklet (usually a PDF from HR): search for “massage”. Your insurer's app or member portal — Sun Life, Canada Life, Manulife and GreenShield all show paramedical coverage in a few taps. Or the helpline on your card: ask “What is my annual maximum for massage therapy, what percentage is covered, and is a doctor's note required?”",
        ],
      },
      {
        h: "The detail people miss",
        p: [
          "Some plans require a physician's referral once per year for reimbursement — a five-minute doctor visit that unlocks the entire year's coverage. Check this before your first claim; it is the most common reason claims get denied.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "doctor-referral-for-massage-insurance",
    title: "Do You Need a Doctor's Referral for Insurance-Covered Massage?",
    keyword: "do I need doctor referral for massage insurance",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I3,
    excerpt:
      "Sometimes yes, often no — and it depends entirely on your plan. How to find out, and what a referral should say if you need one.",
    body: [
      {
        p: [
          "You never need a referral to see a massage therapist. The question is only whether your insurance plan requires one to pay for it. Roughly speaking: many plans do not require a referral at all, some require one per year, and a few require one per condition.",
        ],
      },
      {
        h: "If your plan asks for one",
        p: [
          "A referral is a short note from a physician or nurse practitioner recommending massage therapy, usually dated within the current year. It does not need to name a diagnosis in detail — “massage therapy recommended for musculoskeletal concerns” is typically sufficient. Bring a copy to your first appointment and keep one for your records.",
        ],
      },
      {
        h: "The easy order of operations",
        p: [
          "Check your plan first. If a referral is required, mention it at your next doctor's visit — most physicians write these routinely. Then book. Your coverage starts flowing from the very first session.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "direct-billing-vs-reimbursement-massage",
    title: "Direct Billing vs. Pay-and-Claim: What Is the Difference?",
    keyword: "direct billing vs reimbursement massage",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I1,
    excerpt:
      "Two ways the same benefit reaches you — one instant, one by mail. Why the difference changes how often people actually book.",
    body: [
      {
        p: [
          "Both paths end at the same place: your insurer pays its share of your massage. The difference is entirely in whose money travels and when.",
        ],
      },
      {
        h: "Pay-and-claim",
        p: [
          "You pay the full session price, keep the receipt, submit it to your insurer (app, portal or paper form), and receive reimbursement days or weeks later. It works, but it front-loads the cost onto you and quietly discourages regular care.",
        ],
      },
      {
        h: "Direct billing",
        p: [
          "The clinic submits the claim at the time of your visit. The insurer pays its share directly to the clinic, and you pay only the uncovered remainder — often zero. No receipts to photograph, no claims to track.",
          "If your plan allows it, direct billing is simply the better experience. That is why it is the default at Royal Essence whenever your insurer supports it.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-direct-billing-insurance-companies",
    title: "Which Insurance Companies Accept Direct Billing for Massage?",
    keyword: "massage direct billing insurance companies",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I2,
    excerpt:
      "The major Canadian insurers almost all support direct billing for massage therapy. The short list — and the one caveat that matters.",
    body: [
      {
        p: [
          "Most large Canadian insurers participate in direct billing for massage therapy through the standard provider networks. The familiar names — Sun Life, Canada Life, Manulife, GreenShield, Blue Cross, Desjardins, Industrial Alliance and others — are generally all supported.",
        ],
      },
      {
        h: "The caveat",
        p: [
          "Direct billing depends on your specific plan, not just the insurer's name. Some employer plans opt out of assignment of benefits, and a few smaller insurers route claims differently. The name on your card is a strong hint, not a guarantee.",
        ],
      },
      {
        h: "The ten-second answer",
        p: [
          "Bring your benefits card to your first appointment. The claim system checks your plan in real time — you will know before your massage begins exactly what is covered and what, if anything, you will pay.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "sun-life-massage-direct-billing",
    title: "Direct Billing Massage Through Sun Life: How It Works",
    keyword: "Sun Life massage direct billing",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I3,
    excerpt:
      "Sun Life plans typically cover RMT sessions and support direct billing. What to bring and what the visit looks like.",
    body: [
      {
        p: [
          "Sun Life is one of Canada's largest group benefits providers, and most of its extended health plans include massage therapy — typically at 80–100% coverage up to an annual maximum. Sun Life fully supports direct billing for registered massage therapy.",
        ],
      },
      {
        h: "Your visit, step by step",
        p: [
          "Bring your Sun Life benefits card (physical or in the app). At your first visit, your plan and member ID are entered once. The claim is submitted while you are in the room, Sun Life responds almost immediately, and you pay only any uncovered remainder.",
        ],
      },
      {
        h: "Two things worth checking",
        p: [
          "Some Sun Life plans require a physician's referral — check your booklet once, and the note covers the whole year. And your annual maximum resets each calendar or benefit year: unused coverage does not roll over, so the autumn months are a good time to book.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "canada-life-massage-direct-billing",
    title: "Direct Billing Massage Through Canada Life",
    keyword: "Canada Life massage direct billing",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I1,
    excerpt:
      "Canada Life plans commonly include massage therapy with direct billing. How to use yours — and the groupNET detail that helps.",
    body: [
      {
        p: [
          "If your benefits come through Canada Life, massage therapy is likely included in your extended health coverage. Canada Life supports direct billing through its provider networks, which means most clients pay little or nothing at the appointment.",
        ],
      },
      {
        h: "What you need",
        p: [
          "Your plan and certificate numbers — both are on your Canada Life card or in the groupNET member portal. A photo of the card is enough for the first visit. The claim is processed in the room, and any remainder is settled before you leave.",
        ],
      },
      {
        h: "Worth knowing",
        p: [
          "Canada Life plans vary in their referral requirements — a quick look at your booklet under “paramedical services” settles it. If your plan year resets in January, December sessions are the classic way to use what remains.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "manulife-massage-direct-billing",
    title: "Direct Billing Massage Through Manulife",
    keyword: "Manulife massage direct billing",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I2,
    excerpt:
      "Manulife covers RMT services under most group plans and supports direct billing. What to expect at your appointment.",
    body: [
      {
        p: [
          "Manulife group benefit plans typically include massage therapy as a paramedical benefit, and Manulife processes direct-billed claims quickly — usually within seconds of submission.",
        ],
      },
      {
        h: "The appointment flow",
        p: [
          "Provide your Manulife plan and ID numbers at your first visit (the card in your app works perfectly). The claim goes through while you are still in the room; you see immediately what Manulife covers and pay only the difference, if any.",
        ],
      },
      {
        h: "Plan-specific notes",
        p: [
          "Manulife plans differ on two details: whether a doctor's referral is needed, and whether the annual maximum is shared with other paramedical services or separate. Both are listed in your benefits booklet — or ask, and we can look at the coverage response together at your first visit.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "greenshield-massage-direct-billing",
    title: "Direct Billing Massage Through GreenShield",
    keyword: "GreenShield massage direct billing",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I3,
    excerpt:
      "GreenShield pioneered direct billing in Canada. Using your GreenShield plan for massage could not be simpler.",
    body: [
      {
        p: [
          "GreenShield has supported direct billing longer than any other Canadian insurer — it is built into how they work. Most GreenShield plans include massage therapy under paramedical benefits, with the usual percentage-plus-annual-maximum structure.",
        ],
      },
      {
        h: "Using it here",
        p: [
          "Your GreenShield ID card (or the number in your online account) is all that is needed. Claims submit and approve in real time; you pay only what the plan does not cover. If your plan requires a physician's referral, the response will say so — and it is a one-time-per-year note.",
        ],
      },
      {
        h: "A small GreenShield habit",
        p: [
          "GreenShield's online account shows your remaining massage maximum at a glance. A thirty-second check before booking tells you exactly where you stand for the year.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-insurance-claim-denied",
    title: "What to Do If Your Insurance Denied a Massage Claim",
    keyword: "massage insurance claim denied",
    category: "RMT, Insurance & Direct Billing",
    read: "4 min read",
    img: I1,
    excerpt:
      "Denied does not mean done. The four usual reasons massage claims are refused — and the fix for each.",
    body: [
      {
        p: [
          "A denied claim feels final but usually is not. Most massage claim rejections come down to one of four fixable administrative reasons rather than a real absence of coverage.",
        ],
      },
      {
        h: "The usual four",
        p: [
          "A missing physician's referral on plans that require one — supply the note and resubmit. The therapist's registration number not recognized — a detail your therapist corrects on the invoice. The annual maximum already reached — the claim was valid, the budget simply empty. Or a clerical mismatch: a digit wrong in a policy or certificate number.",
        ],
      },
      {
        h: "The order of operations",
        p: [
          "Call your insurer and ask for the exact denial reason in plain words — agents resolve most of these on the spot. If it was the referral, get the note and resubmit; claims can usually be backdated to the appointment. And keep every massage receipt until the claim clears — the paper trail is what makes resubmission painless.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "coordination-of-benefits-massage",
    title: "Using Your Spouse's Benefits for Massage: Coordination of Benefits Explained",
    keyword: "coordination of benefits massage therapy",
    category: "RMT, Insurance & Direct Billing",
    read: "4 min read",
    img: I2,
    excerpt:
      "Two benefit plans in one household can cover nearly 100% of a session. How coordination of benefits works for couples and families.",
    body: [
      {
        p: [
          "If both you and your spouse have benefit plans, you likely have double coverage — and most households never use it. Coordination of benefits is the mechanism that lets the second plan pay what the first one did not.",
        ],
      },
      {
        h: "How the order works",
        p: [
          "Your own plan is always billed first for your massage. Whatever remains unpaid — the 20% gap, or the amount past your annual maximum — can then be submitted to your spouse's plan, which often covers most or all of it. For children, the plan of the parent whose birthday falls earlier in the year goes first.",
        ],
      },
      {
        h: "Making it practical",
        p: [
          "Direct billing typically handles the first plan automatically; the second claim is a quick submission with the receipt. Net result: two moderate plans frequently equal fully covered massages for the whole family. Check both booklets once — the combined maximums are usually pleasantly surprising.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "rmt-direct-billing-edmonton",
    title: "RMT with Direct Billing in Edmonton: Booking Step by Step",
    keyword: "RMT direct billing Edmonton",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I3,
    excerpt:
      "From benefits card to massage table in one visit — how booking with direct billing works at Royal Essence in Edmonton.",
    body: [
      {
        p: [
          "Booking an RMT session with direct billing in Edmonton is deliberately simple. Here is the entire process, start to finish.",
        ],
      },
      {
        h: "The steps",
        p: [
          "Book your session online — any massage service qualifies. Before or at your first visit, share your benefits card (a photo works) and, if your plan requires it, your physician's referral note. Then simply have your massage. The claim is submitted while you are in the room; you pay only whatever portion your plan does not cover — frequently nothing.",
        ],
      },
      {
        h: "After the first visit",
        p: [
          "Your details stay on file, so every following session is: arrive, exhale, leave. The insurance part happens invisibly in the background — exactly as care should feel.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "registered-massage-therapist-near-me",
    title: "How to Find a Registered Massage Therapist Near You",
    keyword: "registered massage therapist near me",
    category: "RMT, Insurance & Direct Billing",
    read: "4 min read",
    img: T1,
    excerpt:
      "“Near me” finds distance, not fit. What to check once the map gives you names — training, consultation style, billing, and the first-session test.",
    body: [
      {
        p: [
          "A map search for “registered massage therapist near me” answers the easy question. The more useful question is which of those pins is right for your body. A few filters make the choice quick.",
        ],
      },
      {
        h: "The four checks",
        p: [
          "Training: in Alberta, look for graduation from a recognized 2,200-hour program and professional association membership — this also unlocks insurance. Approach: does the therapist describe individualized treatment, or a menu of routines? Billing: direct billing support saves real money over a year. And logistics: hours and location that you will actually keep.",
        ],
      },
      {
        h: "The deciding test",
        p: [
          "Book one session. The right therapist starts with questions about your body, adjusts pressure through conversation, and ends with honest guidance about what would help next. You will know within one visit — trust that signal over any rating.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-therapist-accepting-new-patients-edmonton",
    title: "Royal Essence Is Accepting New Massage Clients in Edmonton",
    keyword: "massage therapist accepting new patients Edmonton",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: T2,
    excerpt:
      "New clients are welcome — here is exactly what your first visit at Royal Essence looks like, from booking to aftercare.",
    body: [
      {
        p: [
          "Yes — Royal Essence Massage is currently welcoming new clients in Edmonton. If you have been putting off a first appointment, here is the whole picture so there are no unknowns.",
        ],
      },
      {
        h: "Your first visit",
        p: [
          "Book online at a time that suits you. You will be greeted, asked a few short questions about your health history and what brings you in, and the session is then composed around your answers — no two first visits are identical. Direct billing is set up in minutes if you have benefits, and you leave with a clear, honest recommendation about what would serve you next.",
        ],
      },
      {
        h: "Who tends to book",
        p: [
          "Desk workers with necks and backs that have been asking for attention. Active people managing training loads. New parents. Anyone who has realized that an hour belonging entirely to them is not a luxury, but maintenance.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-therapist-open-late-edmonton",
    title: "Evening and Weekend Massage in Edmonton: Choosing a Time That Actually Works",
    keyword: "massage therapist open late Edmonton",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I1,
    excerpt:
      "The best appointment time is the one you will keep. How to choose between evening and weekend sessions — and how to actually get them.",
    body: [
      {
        p: [
          "Massage benefits expire quietly when the booking never fits the calendar. Choosing the right slot is less about preference and more about what your week realistically protects.",
        ],
      },
      {
        h: "Evening sessions",
        p: [
          "An evening appointment lands after the day's tension has accumulated — many clients find the release deeper, and sleep afterwards noticeably better. The trade-off: evening slots are the most requested and book out first.",
        ],
      },
      {
        h: "Weekend sessions",
        p: [
          "Weekend massage offers what weekday cannot: no rushing back to a desk. The body stays loose for the rest of the day instead of being sat on again immediately. For chronic tension work, this recovery window genuinely helps results.",
          "Either way — book the next session before you leave the current one. Consistency beats intensity, and the calendar fills the gaps it is given.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "is-deep-tissue-massage-covered-by-insurance",
    title: "Is Deep Tissue Massage Covered by Insurance?",
    keyword: "is deep tissue massage covered by insurance",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: T1,
    excerpt:
      "Good news: insurers cover the therapist, not the technique. Deep tissue, Swedish and hot stone are all billed the same way.",
    body: [
      {
        p: [
          "Yes — with one clarification that simplifies everything. Insurance plans cover registered massage therapy as a service; they do not distinguish between deep tissue, Swedish, or other techniques. If your plan covers massage and your therapist is an RMT, deep tissue sessions are covered exactly the same way.",
        ],
      },
      {
        h: "What the receipt says",
        p: [
          "Your receipt will read “massage therapy” regardless of the techniques used in the session. There is no separate billing code for deep tissue work, and no insurer asks whether the pressure was firm.",
        ],
      },
      {
        h: "The practical result",
        p: [
          "Choose the session your body needs, not the one you assume insurance prefers. Direct billing applies equally — a 90-minute customized deep tissue session bills and covers just like any other massage appointment.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "use-massage-benefits-before-year-end",
    title: "Use Your Massage Benefits Before the Year Ends",
    keyword: "use massage benefits before year end",
    category: "RMT, Insurance & Direct Billing",
    read: "3 min read",
    img: I2,
    excerpt:
      "Most benefit maximums reset on January 1st — and unused coverage does not roll over. The calm case for booking before December is gone.",
    body: [
      {
        p: [
          "Here is a small autumn truth: most extended health plans reset their massage maximum on January 1st, and whatever you did not use simply disappears. Canadians leave hundreds of dollars of coverage unused every year — not because they declined care, but because December arrived faster than expected.",
        ],
      },
      {
        h: "The two-minute check",
        p: [
          "Open your insurer's app and look at your remaining massage maximum. If a meaningful amount is left, that is prepaid care sitting idle. Two or three sessions before year-end is entirely realistic — and December's stress, travel and cold are exactly when backs and shoulders ask for attention.",
        ],
      },
      {
        h: "One scheduling note",
        p: [
          "Everyone realizes this in December, so the final two weeks of the year book out quickly. Late November is the sweet spot: same benefits, calmer calendar.",
        ],
      },
    ],
    note: null,
  },
];
